<template>
  <button 
    class="floating-button"
    :class="[size, variant]"
    @click="$emit('click')"
    :title="label"
  >
    <span class="fab-icon">{{ icon }}</span>
    <span v-if="showLabel" class="fab-label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'FloatingButton',
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'normal',
      validator: value => ['small', 'normal', 'large'].includes(value)
    },
    variant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary', 'success', 'warning', 'danger'].includes(value)
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click']
}
</script>

<style scoped>
.floating-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.floating-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.3);
}

.floating-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

/* 尺寸变体 */
.floating-button.small {
  width: 40px;
  height: 40px;
}

.floating-button.normal {
  width: 56px;
  height: 56px;
}

.floating-button.large {
  width: 72px;
  height: 72px;
}

/* 颜色变体 */
.floating-button.primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.floating-button.secondary {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: white;
}

.floating-button.success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}

.floating-button.warning {
  background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
  color: white;
}

.floating-button.danger {
  background: linear-gradient(135deg, #dc3545 0%, #e83e8c 100%);
  color: white;
}

.fab-icon {
  font-size: 20px;
  line-height: 1;
}

.fab-label {
  position: absolute;
  right: 100%;
  margin-right: 12px;
  background: rgba(0,0,0,0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.floating-button:hover .fab-label {
  opacity: 1;
}

.fab-label::after {
  content: '';
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-left-color: rgba(0,0,0,0.8);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .floating-button.normal {
    width: 48px;
    height: 48px;
  }
  
  .fab-icon {
    font-size: 18px;
  }
}
</style>
